export interface HrCaseDashboard {
  owningCompanyId?: number;
  totalCases?: number;
  openCases?: number;
  closedCases?: number;
  highSeverityCases?: number;
  pendingAcknowledgements?: number;
  activeAccessGrants?: number;
  recentCases?: HrCase[];
}

export interface HrCase {
  caseId?: number;
  owningCompanyId?: number;
  caseCode?: string;
  caseTitle?: string;
  caseType?: string;
  caseStatus?: string;
  severity?: string;
  confidentialityLevel?: string;
  employeeId?: number;
  employeeName?: string;
  employeeNumber?: string;
  assignedEmployeeId?: number;
  assignedEmployeeName?: string;
  openedByCustomerId?: number;
  assignedByCustomerId?: number;
  slaDueDate?: string;
  openedAt?: string;
  closedAt?: string;
  sealedAt?: string;
  sealedByCustomerId?: number;
  sourceObjectType?: string;
  sourceObjectId?: number;
  summary?: string;
  resolution?: string;
  tags?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface HrCaseActivity {
  caseActivityId?: number;
  owningCompanyId?: number;
  caseId?: number;
  activityType?: string;
  activityStatus?: string;
  visibility?: string;
  activityTitle?: string;
  activityBody?: string;
  createdByCustomerId?: number;
  createdByEmployeeId?: number;
  createdByEmployeeName?: string;
  acknowledgedByEmployeeId?: number;
  acknowledgedByEmployeeName?: string;
  acknowledgedAt?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface HrCaseAttachment {
  caseAttachmentId?: number;
  owningCompanyId?: number;
  caseId?: number;
  caseActivityId?: number;
  attachmentType?: string;
  confidentialityLevel?: string;
  fileName?: string;
  fileUrl?: string;
  documentId?: number;
  description?: string;
  uploadedByCustomerId?: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface HrDisciplinaryAction {
  disciplinaryActionId?: number;
  owningCompanyId?: number;
  caseId?: number;
  employeeId?: number;
  employeeName?: string;
  employeeNumber?: string;
  actionType?: string;
  actionStatus?: string;
  actionDate?: string;
  effectiveFrom?: string;
  effectiveTo?: string;
  requiresAcknowledgement?: boolean;
  acknowledgedAt?: string;
  acknowledgedByEmployeeId?: number;
  acknowledgedByEmployeeName?: string;
  approvedByCustomerId?: number;
  approvedAt?: string;
  summary?: string;
  outcome?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface HrCaseAccessGrant {
  caseAccessGrantId?: number;
  owningCompanyId?: number;
  caseId?: number;
  granteeCustomerId?: number;
  granteeEmployeeId?: number;
  granteeEmployeeName?: string;
  accessLevel?: string;
  grantReason?: string;
  grantedByCustomerId?: number;
  grantedAt?: string;
  expiresAt?: string;
  revokedAt?: string;
  revokedByCustomerId?: number;
}

export const HR_CASE_TYPES = ['GRIEVANCE', 'DISCIPLINARY', 'PAYROLL_QUERY', 'WORKPLACE_INCIDENT', 'GENERAL'];

export const HR_CASE_STATUSES = ['OPEN', 'IN_REVIEW', 'PENDING_EMPLOYEE', 'RESOLVED', 'CLOSED'];

export const HR_CASE_SEVERITIES = ['LOW', 'MEDIUM', 'HIGH', 'CRITICAL'];

export const HR_CASE_CONFIDENTIALITY_LEVELS = ['INTERNAL', 'HR_RESTRICTED', 'LEGAL_RESTRICTED'];

export const HR_DISCIPLINARY_ACTION_TYPES = ['VERBAL_WARNING', 'WRITTEN_WARNING', 'FINAL_WARNING', 'SUSPENSION', 'TERMINATION_RECOMMENDATION'];

export const HR_DISCIPLINARY_ACTION_STATUSES = ['DRAFT', 'APPROVED', 'ISSUED', 'ACKNOWLEDGED', 'CLOSED'];

